
import { combineReducers } from "redux";
import diseaseRecordsReducer from "./diseaseRecords/Reducer";
import diseasesReducer from "./diseases/Reducer";
import seriesReducer from "./series/Reducer";
import compositeSeriesReducer from "./composite_series/Reducer";

export default combineReducers({ diseaseRecordsReducer, diseasesReducer, seriesReducer, compositeSeriesReducer });
